import { sortCx } from '@/utils/cx';

/**
 * DataTable styles following the Button/Badge sortCx pattern.
 * Provides base layout tokens and size variants for the table component.
 */
export const styles = sortCx({
  common: {
    /** Outer wrapper — fills available space, provides the relative positioning context */
    wrapper:
      'relative flex flex-col h-full w-full overflow-hidden border-t border-[var(--color-border-secondary)]',
    /** Fixed left pane containing pinned columns */
    leftPane:
      'relative z-10 flex-shrink-0 overflow-hidden border-r border-[var(--color-border-secondary)]',
    /** Scrollable right pane containing non-pinned columns */
    rightPane: 'relative flex-1 overflow-auto',
    /** Sticky header row shared across both panes */
    header:
      'sticky top-0 z-20 flex items-center bg-[var(--color-bg-secondary)] border-b border-[var(--color-border-secondary)]',
    /** Individual header cell — 12px font, right border between columns */
    headerCell:
      'flex h-full items-center px-3 text-xs font-medium text-[var(--color-text-tertiary)] select-none shrink-0 border-r border-[var(--color-border-secondary)]',
    /** Virtualizer scroll container */
    scrollContainer: 'relative w-full',
    /** Individual data row — hover handled via state for synchronized pane highlighting */
    row: 'flex w-full border-b border-[var(--color-border-secondary)] transition-colors duration-75',
    /** Individual data cell — 14px font, right border between columns */
    cell: 'flex items-center px-3 py-2 text-sm text-[var(--color-text-primary)] shrink-0 overflow-hidden border-r border-[var(--color-border-secondary)]',
    /** aria-live status region (visually hidden) */
    statusRegion: 'sr-only',
    /** Empty/loading overlay */
    overlay:
      'absolute inset-0 flex items-center justify-center bg-[var(--color-bg-primary)]/60',
  },
  sizes: {
    sm: {
      row: 'min-h-[34px]',
      cell: 'py-1.5',
      headerCell: 'h-8 text-xs',
      header: 'h-8',
    },
    md: {
      row: 'min-h-[42px]',
      cell: 'py-2',
      headerCell: 'h-10 text-xs',
      header: 'h-10',
    },
    lg: {
      row: 'min-h-[54px]',
      cell: 'py-3',
      headerCell: 'h-12 text-sm',
      header: 'h-12',
    },
  },
});
